import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { conversionExamples } from "@/mocks/criacao-sites";

export default function ConversionSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Conversão"
          badgeIcon="ri-focus-3-line"
          badgeTone="secondary"
          title="Seu site precisa gerar oportunidades"
          description="Além de apresentar sua empresa, o site deve facilitar o próximo passo do visitante. Por isso, podemos estruturar chamadas para ação e pontos de contato de acordo com o objetivo do negócio."
        />

        <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.05fr] lg:items-center">
          <Reveal>
            <div className="flex flex-col gap-4">
              {[
                {
                  icon: "ri-user-heart-line",
                  title: "O visitante entende o que você faz",
                  text: "Conteúdo claro e objetivo, sem enrolação.",
                },
                {
                  icon: "ri-cursor-line",
                  title: "O próximo passo fica óbvio",
                  text: "Botões e pontos de contato posicionados na hora certa.",
                },
                {
                  icon: "ri-line-chart-line",
                  title: "O objetivo do negócio guia o layout",
                  text: "Cada seção existe para levar o visitante à ação certa.",
                },
              ].map((item) => (
                <div
                  key={item.title}
                  className="flex items-start gap-4 rounded-xl border border-background-200 bg-background-50 p-5"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                    <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <p className="font-heading text-sm font-semibold text-foreground-950">
                      {item.title}
                    </p>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="rounded-2xl border border-background-200 bg-background-50 p-2">
              <div className="flex items-center gap-2 px-3 py-2">
                <span className="h-2.5 w-2.5 rounded-full bg-background-300"></span>
                <span className="h-2.5 w-2.5 rounded-full bg-background-300"></span>
                <span className="h-2.5 w-2.5 rounded-full bg-background-300"></span>
                <span className="ml-2 flex-1 rounded-md bg-background-100 px-3 py-1 text-[11px] text-foreground-500">
                  www.suaempresa.com.br
                </span>
              </div>
              <div className="rounded-xl bg-foreground-950 p-6 text-background-50 md:p-8">
                <span className="text-[11px] uppercase tracking-wide text-background-400">
                  O próximo passo
                </span>
                <h3 className="mt-2 font-heading text-xl font-bold">
                  Pronto para falar com a sua empresa?
                </h3>
                <p className="mt-2 text-sm text-background-300">
                  Pontos de contato pensados para transformar visitas em oportunidades.
                </p>
                <div className="mt-5 flex flex-wrap gap-2">
                  {conversionExamples.map((item, index) => (
                    <span
                      key={item.label}
                      className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs font-semibold ${
                        index === 0
                          ? "bg-primary-500 text-background-50"
                          : "border border-background-50/15 bg-background-50/5 text-background-100"
                      }`}
                    >
                      <i className={`${item.icon} text-sm`} aria-hidden="true"></i>
                      {item.label}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}